module.exports = __webpack_public_path__ + "img/iptv-web-ui.7447e00c.png";